import { DateRangeContext } from "../../store/DashboardDateRangeContext";
import DomainDetailModal from "../Centralized/DomainDetailModal";
import AggrementDomainListModal from "./AggrementDomainListModal";
import CurrentMonthMemberModal from "./CurrentMonthMemberModal";
import SegmentDomainListModal from "./SegmentDomainListModal";
import FlagsDomainListModal from "./FlagsDomainListModal";
import CurrentDataModal from "./CurrentDataModal";
import DomainListModal from "../DomainListModal";
import { useState, useContext } from "react";
import Div from "../Div";
import DailyDashboard from "./DailyDashboard";


export default function RenewalTeam({ title, data, columns, selectedMonth, tag }) {

    const [teamDomainListModal, setTeamDomainListModal] = useState(false);

    const [segmentDomainListModal, setSegmentDomainListModal] = useState(false);

    const [aggrementDomainListModal, setAggrementDomainListModal] = useState(false);

    const [flagsDomainListModal, setFlagsDomainListModal] = useState(false);

    const [currentDataModal, setCurrentDataModal] = useState(false);

    const [centralized, setCentralized] = useState(false);

    const [reseller, setReseller] = useState(false);

    const [member, setMember] = useState(false);

    const month = useContext(DateRangeContext)


    function handleTeamDomainClick(data, tag) {

        if (tag === 'team') {
            const admin = {
                admin_email: data,
                month : selectedMonth
            }
            
            setTeamDomainListModal(admin)
        }

        if (tag === 'segments') {
            // const segments = {
            //     segment: data
            // }
            setSegmentDomainListModal(data)
        }
        if (tag === 'aggrements') {
            setAggrementDomainListModal(data)
        }
        if (tag === 'flags') {
            setFlagsDomainListModal(data)
        }
        if(tag === 'current'){
            setCurrentDataModal(data)
        }
        if(tag === 'centralized'){
            setCentralized(data)
        }
        if(tag === 'member'){
            
            setMember(data)
        }
        if(tag === 'reseller_member'){
            setReseller(data)   
        }

    }


    return <>

        {reseller ? <></> : null}

        {teamDomainListModal ? <DomainListModal show={true.toString()} open admin={teamDomainListModal}
            handleClicked={setTeamDomainListModal} /> : null}

        {segmentDomainListModal ? <SegmentDomainListModal show={true.toString()} open
            segment={segmentDomainListModal.data} month={month} handleClicked={setSegmentDomainListModal} /> : null}

        {aggrementDomainListModal ? <AggrementDomainListModal show={true.toString()} open
            aggrement={aggrementDomainListModal} handleClicked={setAggrementDomainListModal} /> : null}

        {flagsDomainListModal ? <FlagsDomainListModal show={true.toString()} open
            flags={flagsDomainListModal} handleClicked={setFlagsDomainListModal} /> : null}

        {currentDataModal ? <CurrentDataModal show={true.toString()} open
            flags={currentDataModal} handleClicked={setCurrentDataModal} /> : null}

        {centralized ? <DomainDetailModal show={true.toString()} open
            domain_name={centralized} handleClicked={setCentralized} /> : null}

        {member ? <CurrentMonthMemberModal show={true.toString()} open
            flags={member} handleClicked={setMember} /> : null}

         {member ? <DailyDashboard show={true.toString()} open
            flags={member} handleClicked={setMember} /> : null}


     <label style={{ marginLeft: '25%' }}><strong>{title}</strong></label>
        <Div
            className="table-responsive mdc-data-table--sticky-header"
            style={{ maxHeight: "375px", overflowY: "auto", scrollbarWidth: "thin" }}
        >
       
            <table className="table table-hover sticky-header">
                <thead>
                    <tr>
                        {columns}
                    </tr>
                </thead>
                <tbody>
                    {data ?
                    
                        data.map((domain) =>
                            <tr key={Object.values(domain)[0]}>
                                <td>{Object.values(domain)[0]}</td>
                                <td><button onClick={() => handleTeamDomainClick(Object.values(domain)[0], tag)}
                                    className="btn btn-link">{Object.values(domain)[1]} </button></td>
                            </tr>
                        )
                        : null

                    }
                </tbody>
            </table>
        </Div>
    </>
}